import * as React from 'react';
import { defaultProps } from './defaults';
import { SpanTag } from '../../Utils/AtomicTag';
var StatisticNumber = function (props) {
    var value = props.value, precision = props.precision, _a = props.decimalSeparator, decimalSeparator = _a === void 0 ? '.' : _a, _b = props.groupSeparator, groupSeparator = _b === void 0 ? ',' : _b, _c = props.prefixCls, prefixCls = _c === void 0 ? 'statistic' : _c;
    var valueNode;
    if (React.isValidElement(value)) {
        valueNode = value;
    }
    else {
        var val = String(value);
        // 捕获填充的数字，以及非整数部分（小数点之后之前的部分）
        var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/);
        if (!cells || val === '-') {
            valueNode = val;
        }
        else {
            var negative = cells[1];
            var intVal = cells[2] || '0';
            var decimal = cells[4] || '';
            // 增加千分位符，每3个数字中间增加自定义的分位符
            intVal = intVal.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
            if (typeof precision === 'number' && !isNaN(precision)) {
                decimal = decimal.padEnd(precision, '0').slice(0, precision);
            }
            if (decimal) {
                decimal = "" + decimalSeparator + decimal;
            }
            valueNode = [
                React.createElement(SpanTag, { key: "intVal", autoPrefixedClassName: prefixCls + "-content-value-int" },
                    negative,
                    intVal),
                decimal && (React.createElement(SpanTag, { key: "decimal", autoPrefixedClassName: prefixCls + "-content-value-decimal" }, decimal)),
            ];
        }
    }
    return React.createElement(SpanTag, { autoPrefixedClassName: prefixCls + "-content-value" }, valueNode);
};
StatisticNumber.defaultProps = defaultProps;
export default StatisticNumber;
